import React from "react";
import { TIMELINE, ResearchLens } from "../../data/research";
import { useReveal } from "../../hooks/useReveal";
import styles from "./ResearchTimeline.module.css";

function Bullets({
  bullets,
}: {
  bullets: (typeof TIMELINE)[number]["bullets"];
}) {
  return (
    <ul>
      {bullets.map(({ text, href }) => (
        <li key={text}>
          {href ? (
            <a
              className="ui-link"
              href={href}
              target="_blank"
              rel="noopener noreferrer"
            >
              {text}
              <span className="ui-visually-hidden"> (opens in new tab)</span>
            </a>
          ) : (
            text
          )}
        </li>
      ))}
    </ul>
  );
}
export function ResearchTimeline({ lens }: { lens: ResearchLens }) {
  const ref = useReveal<HTMLElement>();
  return (
    <section
      ref={ref}
      className={`ui-reveal ${styles.section}`}
      aria-labelledby="timeline-title"
    >
      <span className="ui-section-label">Nine years of work</span>
      <h2 id="timeline-title">From focus group to multi-site study</h2>
      <ol className={styles.stops}>
        {TIMELINE.map((stop, index) => (
          <li key={stop.title} className={styles.stop}>
            <span
              className={`${styles.node} ${stop.live ? styles.live : ""}`}
              aria-hidden="true"
            >
              {index + 1}
            </span>
            <h3>{stop.title}</h3>
            {stop.live && (
              <span className="ui-badge ui-badge--success">Underway</span>
            )}
            <p className={styles.meta}>{stop.meta}</p>
            <Bullets
              bullets={
                lens === "provider" ? stop.bullets : stop.bullets.slice(0, 2)
              }
            />
            {lens === "patient" && stop.bullets.length > 2 && (
              <details>
                <summary>
                  Show details
                  <span className="ui-visually-hidden">: {stop.title}</span>
                </summary>
                <Bullets bullets={stop.bullets.slice(2)} />
              </details>
            )}
          </li>
        ))}
      </ol>
    </section>
  );
}
